<template>
  <div class="project">
    <h3>Лимиты индексированных страховых сумм по договорам накопительного страхования жизни</h3>
    <table>
      <tr>
        <th>Страховой риск</th>
        <th>Лимит (руб.)</th>
      </tr>
      <tr>
        <td>Дожитие до окончания срока страхования</td>
        <td>20 000 0000</td>
      </tr>
      <tr>
        <td>Смерть от любой причины</td>
        <td>20 000 0000</td>
      </tr>
      <tr>
        <td>Критическое заболевание</td>
        <td>1 000 000</td>
      </tr>
      <tr>
        <td>Лечение критического заболевания</td>
        <td>60 000 000</td>
      </tr>
      <tr>
        <td>Смерть в результате НС (для застрахованных в возрасте до 75 лет)</td>
        <td>7 000 000</td>
      </tr>
      <tr>
        <td>Смерть в результате НС (для застрахованных в возрасте от 76 лет)</td>
        <td>300 000</td>
      </tr>
      <tr>
        <td>Смерть в результате ДТП</td>
        <td>7 000 000</td>
      </tr>
      <tr>
        <td>Травма в результате НС</td>
        <td>1 000 000</td>
      </tr>
      <tr>
        <td>Инвалидность I, II группы в результате НС</td>
        <td>В размере годового индексированного взноса по договору на дату индексации, но не более 20 000 000</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "ProjectView"
};
</script>

<style scoped>

</style>